import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import {
  FullProjectTechnician,
  ProjectTechnicianUpdateParams
} from "../_models/project-technician.interface";

@Injectable({
  providedIn: 'root'
})
export class ProjectTechnicianService {

  constructor(private http: HttpClient) {
  }

  public createProjectTechnician(project_technician: ProjectTechnicianUpdateParams) {
    const path = environment.apiURL + `projects_technicians`

    return this.http.post<FullProjectTechnician>(path, { project_technician })
  }

  public updateProjectTechnician(id: number, project_technician: ProjectTechnicianUpdateParams) {
    const path = environment.apiURL + `projects_technicians/${id}`

    return this.http.patch<FullProjectTechnician>(path, { project_technician })
  }

  public deleteProjectTechnician(id: number) {
    const path = environment.apiURL + `projects_technicians/${id}`

    return this.http.delete<void>(path)
  }
}
